const DEFAULT_DURATION_SECS = 1800;

const appendQuestions = (target, questions, type) => {
  if (!questions) {
    return;
  }
  questions.forEach((question) => {
    question.type = type;
    target.push(question);
  });
};

/**
 * Get the duration in seconds for a given test category
 * @param category {string} Test license category
 * @returns {*|number} Duration in seconds for the given test category
 */
export const testDurationInSeconds = (category) => {
  return {
    'taxi': 2700,
    'adr_p': 2700,
    'adr_tps17': 2700,
    'adr_yp': 3600
  }[category] ?? DEFAULT_DURATION_SECS;
};

export const getFullTestAnswerKey = (question, index) => {
  return `${question.type}-${question.id}-${index}`;
};

export function createFullTest(apiTestData) {
  {
    const questions = [];
    appendQuestions(questions, apiTestData.literalQuestions, "literal");
    appendQuestions(questions, apiTestData.signQuestions, "sign");
    appendQuestions(questions, apiTestData.riskQuestions, "risk");
    appendQuestions(questions, apiTestData.imageQuestions, "image");

    const { id, category } = apiTestData;
    return { id, category, questions };
  }
}

export function formatFulltestAnswers(questions, allAnswers) {
  const answers = {};
  // Group answers by question type
  questions.forEach((question, index) => {
    let answer = allAnswers[getFullTestAnswerKey(question, index)];
    if (!answer) {
      answer = "d";
    }
    const prop = question.type + "Answers";
    if (!answers.hasOwnProperty(prop)) {
      answers[prop] = [];
    }
    answers[prop].push(answer);
  });

  return answers;
}
